// extracted by mini-css-extract-plugin
export default {"wrapper":"DocumentUploadModal_wrapper__OEt7e","icon":"DocumentUploadModal_icon__5aM6-","upload":"DocumentUploadModal_upload__Yv1Nn","close":"DocumentUploadModal_close__AbQXI"};